/**
 * 贴纸/表情面板懒加载壳（21d-3 首屏瘦身；MeTabLazy 同构）。
 * 面板只有点 ☺ 才出现，却因为被 Composer 静态引用而一直待在首屏块里。
 * 加载中返回 null：面板本身是个浮层，晚一帧出来比先闪个空壳好。
 */
import { useLazyModule } from './useLazyModule';
import type * as Mod from './StickerPanel';
import type { ComponentProps } from 'preact';

type Props = ComponentProps<typeof Mod.StickerPanel>;

export function StickerPanelLazy(props: Props) {
  const { mod } = useLazyModule(() => import('./StickerPanel'));
  if (mod === null) return null;
  return <mod.StickerPanel {...props} />;
}
